import JSZip from 'jszip';
import { getMedia } from '@/lib/db';
import type { RenderJob } from '@/types';

export async function downloadAllAsZip(jobs: RenderJob[], zipFileName = 'reels-export.zip'): Promise<void> {
  const completed = jobs.filter((j) => j.status === 'complete' && j.resultMediaId);
  if (completed.length === 0) return;

  const zip = new JSZip();
  await Promise.all(
    completed.map(async (job) => {
      const record = await getMedia(job.resultMediaId!);
      if (record) zip.file(job.resultFileName ?? `${job.id}.mp4`, record.blob);
    })
  );

  const blob = await zip.generateAsync({ type: 'blob' });
  triggerDownload(blob, zipFileName);
}

export async function downloadSingle(job: RenderJob): Promise<void> {
  if (!job.resultMediaId) return;
  const record = await getMedia(job.resultMediaId);
  if (!record) return;
  triggerDownload(record.blob, job.resultFileName ?? `${job.id}.mp4`);
}

function triggerDownload(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
